function debounce(func, wait, immediate = false) {
  let timeout;
  return function (...args) {
    var context = this,
      args = arguments;
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    }, wait);
    if (immediate && !timeout) func.apply(context, args);
  };
}

export { debounce };
